import { isOptimizelyLoaded } from './is-optimizely-loaded';

export function waitForOptimizelyValueUsingMutationObserver(
    callback: () => void
) {
    const observer = new MutationObserver((_, observer) => {
        if (isOptimizelyLoaded(window)) {
            callback();
            observer.disconnect();
        }
    });

    observer.observe(document.documentElement, {
        childList: true,
        subtree: true,
    });
}
